// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const alpaca = defineModel({
  id: "alpaca",
  scale: 2.48, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Alpaca",
  tags: ["creature","alpaca","low-poly","age-of-mcp","future"],
  summary: "An alpaca — kept for its fine, prized fleece.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.1,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.009, 0.0075, 0.05, 5), color: "#9a9081", position: [0.04, 0.025, 0.028] },
      { geometry: new THREE.CylinderGeometry(0.009, 0.0075, 0.05, 5), color: "#9a9081", position: [0.04, 0.025, -0.028] },
      { geometry: new THREE.CylinderGeometry(0.009, 0.0075, 0.05, 5), color: "#9a9081", position: [-0.04, 0.025, 0.028] },
      { geometry: new THREE.CylinderGeometry(0.009, 0.0075, 0.05, 5), color: "#9a9081", position: [-0.04, 0.025, -0.028] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#e0d8c6", position: [0, 0.095, 0], scale: [1.3, 1.15, 1.05] },
      { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#ece5d6", position: [0.045, 0.15, 0], scale: [1, 1.2, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#ece5d6", position: [0.052, 0.185, 0], scale: [1, 1.1, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#ece5d6", position: [0.06, 0.21, 0], scale: [1.1, 1, 0.9] },
      { geometry: new THREE.BoxGeometry(0.018, 0.013, 0.016), color: "#ece5d6", position: [0.076, 0.204, 0] },
      { geometry: new THREE.ConeGeometry(0.007, 0.016, 4), color: "#e0d8c6", position: [0.052, 0.228, 0.01], rotation: [0.2, 0, 0.1] },
      { geometry: new THREE.ConeGeometry(0.007, 0.016, 4), color: "#e0d8c6", position: [0.052, 0.228, -0.01], rotation: [-0.2, 0, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.07, 0.216, 0.012] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.07, 0.216, -0.012] },
      { geometry: new THREE.IcosahedronGeometry(0.014, 0), color: "#e0d8c6", position: [-0.058, 0.105, 0], scale: [0.9, 1.1, 0.9] },
    ],
  animations: [],
});
